import markAttendance from "./markAttendance";
import safetyMeetingDone from "./safetyMeetingDone";
import viewSafetyMeeting from "./viewSafetyMeeting";
import safetyMeetingParticipant from "./safetyMeetingParticipant";
import safetyMeetingRequestStatus from "./safetyMeetingRequestStatus";
import badgeScanner from "./badgeScanner";
import scanAttendance from "./scanAttendance";
import manualAttendance from "./manualAttendance";
import publicSafetyMeetingTopic from "./publicSafetyMeetingTopic";
import publicSafetyMeetingTopicList from "./publicSafetyMeetingTopicList";
import lessonIcon from "./lessonIcon";
import sopLibrary from "./sopLibrary";
import viewSop from "./viewSop";

export default [
    markAttendance,
    safetyMeetingDone,
    viewSafetyMeeting,
    safetyMeetingParticipant,
    safetyMeetingRequestStatus,
    badgeScanner,
    scanAttendance,
    manualAttendance,
    publicSafetyMeetingTopic,
    publicSafetyMeetingTopicList,
    lessonIcon,
    sopLibrary,
    viewSop,
];
